module.exports = __webpack_public_path__ + "img/row-right-white.7b6ea5ab.svg";